module.exports = __webpack_public_path__ + "order/img/paw-avatar.0909ba3c.png";